<mat-toolbar class="header">
  <div class="back" (click)="goBack()" matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div>
    {{ folder().type | human }} #{{ folder().correlative_id }}
  </div>

  <div class="expander"></div>

  <div class="status-chips">
    <app-chip
      [color]="folder().status | folderStatus: 'color'"
      [text]="folder().status | folderStatus">
    </app-chip>
  </div>
</mat-toolbar>

<div class="dialog-wrapper">
  <div class="info">
      <div class="name">{{ 'warehouse' | human }}</div>
      <div class="value">{{folder().extra_params.warehouse_name| titlecase}}</div>

      <div class="name">Proveedores</div>
      <div class="value">{{folder().extra_params.provider_names}}</div>
  </div>

  <div class="request-table">
    <div class="label">
      Productos Requeridos
    </div>
    <div class="table-container">
      <mat-card>
        <mat-card-content style="padding: 0;">
          <table class="transfer-table">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Cantidad Requerida</th>
                <th>Cantidad Confirmada</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (product of folder().extra_params.required_products; track product.product.code) {
                <tr>
                  <td>
                    <div>
                      <div class="name">{{product.product.name}}</div>
                      <div class="code">{{product.product.code}}</div>
                    </div>
                  </td>
                  <td>
                    {{product.quantity}}
                  </td>
                  @let approvedQuantity = approvedQuantityFrom[product.product_id] || 0;
                  <td>
                    {{approvedQuantity}}
                  </td>
                  <td>
                    @if (approvedQuantity >= product.quantity) {
                      <mat-icon class="approved">done</mat-icon>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="offers-table">
    <div class="label">
      Respuestas de Proveedores (Cantidad ofrecida x Precio por unidad).
    </div>
  
    <div class="table-container">
      <mat-card class="">
        <mat-card-content style="padding: 0;">
          <table class="transfer-table">
            <thead>
              <tr>
                <th></th>
                @for(product of inventoryActionProducts; track product.product_id) {
                  <th>{{product.product.name}}</th>
                }
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (child of documents; track child.id) {
                <tr go-to-details [element]="child" (afterClosed)="reload()()" class="cursor-pointer">
                  <td class="th">
                    {{child.owner.name}}
                  </td>
                  @if (!child.extra_params["answered"]) {
                    @for(product of inventoryActionProducts; track product.product_id) {
                      <td>-</td>
                    }
                  } @else {
                    @for(product of sortedProducts(child.extra_params.selected_products); track product.id) {
                      <td matTooltip="{{child.owner.name}} no ofrece este producto" [matTooltipDisabled]="!!product.quantity">
                        @if (product.quantity) {
                          {{product.quantity}} x {{product.amount | money}}
                        } @else {
                          N/O
                        }
                      </td>
                    }
                  }
                  <td class="actions">
                    @if (child.completed) {
                      <div matTooltip="{{'inventory_action/pricing' | human}} Aprobada">
                        <button mat-icon-button disabled  aria-label="Cotización Aprobada">
                          <mat-icon class="approved">done</mat-icon>
                        </button>
                      </div>
                    } @else if (child.failed) {
                      <div matTooltip="{{'inventory_action/pricing' | human}} Rechazada">
                        <button mat-icon-button disabled aria-label="Cotización Rechazada">
                          <mat-icon class="declined" >close</mat-icon>
                        </button>
                      </div>
                    } @else {
                      @if (!child.extra_params["answered"]){
                          <button mat-icon-button matTooltip="Aún no hay respuesta por parte de {{child.owner.name}}" aria-label="Abrir detalle de la cotización">
                            <mat-icon>info</mat-icon>
                          </button>                    
                      }
                      @if (child.last_work) {
                        <button 
                            mat-icon-button
                            go-to-details
                            [element]="child.last_work"
                            [matTooltip]="child.last_work.name | titlecase">
                           <mat-icon class="primary">next_week</mat-icon>
                        </button>
                      }
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
